import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@prezi/dragon';

type DropdownItemProps = {
    id?: string;
    href?: string;
    className?: string;
    target?: '_blank';
    onClick?: (event: React.MouseEvent | React.TouchEvent) => void;
    iconLeft?: React.ReactElement;
    iconRight?: React.ReactElement;
    ref?: React.RefObject<HTMLLIElement>;
    children: any;
    dataLookup?: string;
};

const DropdownLink = styled.a`
    font-size: 14px;
    display: flex;
    color: inherit;
    align-items: center;
    padding: 12px 18px;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    &:hover,
    &:focus {
        color: inherit;
        background: ${Colors.neutral50};
        text-decoration: none;
        outline: none;
    }
`;

const IconWrap = styled.div<{ position: 'left' | 'right' }>`
    flex: 0;
    padding-${({ position }) => (position === 'left' ? 'right' : 'left')}: 12px;
    margin-left: ${({ position }) => (position === 'right' ? 'auto' : '0')};

    & > svg {
        display: block;
    }
`;

const DropdownItem: React.ForwardRefRenderFunction<any, DropdownItemProps> = (
    { id, children, href, target, onClick = () => {}, iconLeft = null, className, iconRight = null, dataLookup },
    ref,
) => (
    <DropdownLink
        id={id}
        ref={ref}
        href={href}
        className={className}
        target={target}
        onClick={onClick}
        onTouchEnd={onClick}
        data-lookup={dataLookup}
    >
        {iconLeft && <IconWrap position="left">{iconLeft}</IconWrap>}
        <div>{children}</div>
        {iconRight && <IconWrap position="right">{iconRight}</IconWrap>}
    </DropdownLink>
);

export default React.forwardRef(DropdownItem);
